export default __webpack_public_path__ + "static/media/disney.9c547fb1.png";